import * as types from "../actions/types";


const initialState = {
  list: [],
  loading: false
};


export default function equipment_groups(state = initialState, action) {
  switch (action.type) {

    case types.SET_EQUIPMENT_GROUPS_LIST:
      return {
        ...state,
        list: action.payload,
      };

    case types.SET_EQUIPMENT_GROUPS_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    default:
      return state;
  }
}
